export default function makeList(values) {
  let valueList = []
  for (const [key, value] of Object.entries(values)) {
    valueList.push(`<li>${key}: ${value}</li>`)
  }
  return `<ul>${valueList.join("")}</ul>`
}
